import React from 'react';
import StatusBadge from '../StatusBadge';
import { HEADER_CELL } from '../../utils/tableColumns';

export default function DistributorShipmentTable({ rows, t, locale, status, view }) {
  return (
    <table className="me-dw-activity-table" aria-label={t('Shipments')}>
      <thead>
        <tr>
          {['Order ID', 'Tracking', 'Carrier', 'Customer', 'Status', 'Date (UTC)', 'Actions'].map(
            (title) => (
              <th key={title} scope="col" className={HEADER_CELL}>
                {t(title)}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row._id}>
            <td className="font-medium">{row.order?.orderId || row.orderId || t('Record')}</td>
            <td>{row.trackingNumber || t('Not set')}</td>
            <td>{row.carrier?.toUpperCase() || t('Not set')}</td>
            <td>
              {row.clinic?.name ||
                row.practice ||
                row.order?.clinic?.name ||
                t('Customer unavailable')}
            </td>
            <td className="whitespace-nowrap">
              <StatusBadge status={status(row)} />
            </td>
            <td className="whitespace-nowrap">
              {row.createdAt && Number.isFinite(new Date(row.createdAt).getTime())
                ? new Date(row.createdAt).toLocaleDateString(locale, {
                    timeZone: 'UTC',
                  })
                : t('Not set')}
            </td>
            <td>
              <button type="button" className="me-dw-link" onClick={() => view(row._id)}>
                {t('View')}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
